import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormValueReadableValue
} from "../../../../type-handler/abstract-field-input-type-handler.component";
import {FormBuilder, FormGroup, UntypedFormControl, Validators} from "@angular/forms";
import {
  FormDefinitionFieldModel
} from "../../../../../../../../modules/form/definition/field/api/entity/formDefinitionField.model";
import {FormValueModel} from "../../../../../../../../modules/form/form/value/api/entity/formValue.model";
import {FileUploadComponent} from "../../../../../../file-upload/file-upload.component";
import {FileItem} from "ng2-file-upload";
import {FileUploadModule} from "../../../../../../file-upload/file-upload.module";
import {
  DrawingOnImageComponent, DrawingOptions
} from "../../../../../../../../modules/common/drawing/drawing-on-image/drawing-on-image.component";
import {Base64Utils} from "../../../../../../../../modules/core/utils/base64.utils";
import {ImageHelper} from "../../../../../../../../modules/common/image/imageHelper";
import {
  DrawableImageV2FieldInputTypeHandlerComponentUtils
} from "../drawableImageV2FieldInputTypeHandlerComponent.utils";
import {AbstractDrawableImageV2InputTypeHandler} from "../AbstractDrawableImageV2InputTypeHandler";

@Component({
  selector: 'app-drawable-image-v2-embedded-file-field-input-type-handler',
  standalone: true,
  imports: [CommonModule, FileUploadModule, DrawingOnImageComponent],
  templateUrl: './drawable-image-v2-embedded-file-field-input-type-handler.component.html',
  styles: [
  ]
})
export class DrawableImageV2EmbeddedFileFieldInputTypeHandlerComponent extends AbstractDrawableImageV2InputTypeHandler
implements OnDestroy, AfterViewInit {
  @ViewChild('fileUpload') fileUploadComponent: FileUploadComponent;
  imageUrl: string;
  drawingData: any = {items: []};
  options: DrawingOptions;

  public static resolveReadableValues(value: any): Promise<FormValueReadableValue[]> {
    return DrawableImageV2FieldInputTypeHandlerComponentUtils.resolveReadableValues(value);
  }

  constructor(private formBuilder: FormBuilder) {
    super();
  }

  ngAfterViewInit(): void {
  }



  ngOnDestroy() {
    this.cleanBackgroundImageUrl();
  }

  removeBackgroundImage(){
    this.cleanBackgroundImageUrl();
    this.jsonControl.patchValue({
      backgroundImage: undefined
    });
  }

  cleanBackgroundImageUrl(){
    if (this.imageUrl) {
      URL.revokeObjectURL(this.imageUrl);
      this.imageUrl = undefined;
    }
  }

  buildJsonControl(formDefinitionField: FormDefinitionFieldModel): FormGroup {
    const data = JSON.parse(formDefinitionField.data);
    this.options = {
      options: data.options
    }

    return this.formBuilder.group({
      image: this.formBuilder.control(undefined),
      backgroundImage: this.formBuilder.control(undefined),
      data: this.formBuilder.control(undefined),
    });
  }

  initiateForm(formValue: FormValueModel): void {
    const value = formValue.value;
    if (value) {
      const parsed = JSON.parse(value);
      console.log('initiateForm', parsed.data)
      if (parsed.backgroundImage) {
        const blob = Base64Utils.base64ToBlob(parsed.backgroundImage);
        this.imageUrl = URL.createObjectURL(blob);
        this.jsonControl.patchValue({
          backgroundImage: parsed.backgroundImage
        });
      }

      if (parsed.data?.items) {
        this.drawingData.items = parsed.data.items.map(value => {
          return {
            typeValue: value.typeValue,
            subTypeValue: value.subTypeValue,
            common: value.common,
            properties: value.properties
          }
        });
      }
    }
  }

  synchronizeValue(): string {
    return this.jsonControl.value ? JSON.stringify(this.jsonControl.value) : undefined;
  }

  onFileAdded(fileItem: FileItem) {
    if (fileItem) {
      this.imageUrl = URL.createObjectURL(fileItem._file);

      ImageHelper.resizeImageBlobIfNeeded(fileItem._file, 1080, 1080)
          .then((resizedBlob: Blob) => {
            this.imageUrl = URL.createObjectURL(resizedBlob);
            this.setMeasured(true);
            Base64Utils.blobToBase64(resizedBlob).then(value => {
              this.jsonControl.patchValue({
                backgroundImage: value,
              });
            })
          })
          .catch((error) => {
            console.error("Erreur lors du redimensionnement de l'image :", error);
          });
      this.fileUploadComponent.reset();
    }
  }
}
